import { Banner, Button } from '@servicecompressionllc/sc-design-system';
import { usePushLogic } from './usePushLogic.js';

/** In a bot's thread, until this browser has decided: one click to get pinged when it writes. */
export const PushAskBanner = ({ botName }: { botName: string }) => {
  const push = usePushLogic();
  if (push.homeScreenDevice)
    return (
      <Banner variant="neutral" className="mx-4 mb-2">
        <Banner.Body>
          <Banner.Title>Get notifications on this {push.homeScreenDevice}</Banner.Title>
          <Banner.Description>
            Tap Share, then Add to Home Screen, and open SC Platform from there. Then you can turn
            them on.
          </Banner.Description>
        </Banner.Body>
        <Banner.Actions>
          <Button size="sm" variant="ghost" onClick={push.notNow}>
            Not now
          </Button>
        </Banner.Actions>
      </Banner>
    );
  if (!push.shouldAsk) return null;
  return (
    <Banner variant="neutral" className="mx-4 mb-2">
      <Banner.Body>
        <Banner.Title>Get a notification when {botName} messages you</Banner.Title>
        <Banner.Description>
          Reminders and watches reach you on this device, even with this page closed.
        </Banner.Description>
      </Banner.Body>
      <Banner.Actions>
        <Button size="sm" disabled={push.isSwitching} onClick={push.turnOn}>
          Allow
        </Button>
        <Button size="sm" variant="ghost" onClick={push.notNow}>
          Not now
        </Button>
      </Banner.Actions>
    </Banner>
  );
};
